import axios from 'axios'

export default {
    // 商户-公司
    getCompanyList({commit}, params){
        return axios.post('/api/background/company/company_list/get', params)
    },
    addCompany({commit}, params){
        return axios.post('/api/background/company/add', params)
    },
    modifyCompany({commit}, params){
        return axios.post('/api/background/company/company_info/set', params)
    },
    deleteCompany({commit}, params){
        return axios.post('/api/background/company/delete', params)
    },
    getCompanyInfo({commit}, params){
        return axios.post('/api/background/company/company_info/get', params)
    },
    getCompanySmsPackageInfo({commit}, params){
        return axios.post('/api/background/product/sms/list_company_sms_package', params)
    },

    // 商户-食堂
    //获取旧版食堂列表
    getCanteenList({commit}, params){
        return axios.post('/api/background/canteen/list', params)
    },
    //获取新版食堂列表
    getShopList({commit}, params){
        return axios.post('/api/background/canteen/new/list', params)
    },
    getShopInfo({commit}, params){
        return axios.post('/api/background/canteen/get', params)
    },
    addShop({commit}, params){
        return axios.post('/api/background/canteen/add', params)
    },
    modifyShop({commit}, params){
        return axios.post('/api/background/canteen/modify', params)
    },
    deleteShop({commit}, params){
        return axios.post('/api/background/canteen/delete', params)
    },
    mulDeleteShop({commit}, params){
        return axios.post('/api/background/canteen/new/delete', params)
    },
    // 食堂使用人脸支付
    setFacePay({commit}, params){
        return axios.post('/api/facepay/shop/facepay/set', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/merchant.js